import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core'
import { CategoryTreeType } from '../../models'
import { CoreService } from '../../services'

@Component({
  selector: 'categories',
  templateUrl: 'categories.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CategoriesComponent {
  private core: CoreService = inject(CoreService)

  categoryTreeTypeEnum = CategoryTreeType

  canCreate = computed(() => {
    return (
      this.core.services.user.hasRole('ROLE_CATEGORY_CREATE') ||
      this.core.services.user.hasRole('ROLE_SUPER_ADMIN') ||
      this.core.services.user.hasRole('ROLE_ADMIN')
    )
  })
}
